import { Injector, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { NG1_HELPZONE_SEARCH_DEPRECATED_SERVICE } from '@commons/core/core.provider.ajs';

import { AGENT_DESKTOP_ACTIONS, TRANSLATION_NS } from '@contact/upgrade';

import { AgentStoreModule } from './store/agent-store.module';

@NgModule({
  imports: [AgentStoreModule],
})
export class AgentCoreForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: AgentCoreForRootModule) {
    if (parentModule) throw new Error(`[AgentCoreForRootModule] module is already loaded`);
  }

  static instance(): ModuleWithProviders<AgentCoreForRootModule> {
    return {
      ngModule: AgentCoreForRootModule,
      providers: [
        {
          provide: TRANSLATION_NS,
          useValue: 'agent',
          multi: true,
        },
        {
          provide: TRANSLATION_NS,
          useValue: 'reduced-agent',
          multi: true,
        },

        {
          provide: AGENT_DESKTOP_ACTIONS,
          useFactory: (injector: Injector) => injector.get(NG1_HELPZONE_SEARCH_DEPRECATED_SERVICE),
          deps: [Injector],
        },
      ],
    };
  }
}
